/* eslint-disable  */

import { useSelector } from 'react-redux';
import { decodeQueryParamData } from 'utils/utils';
import { useEffect, useMemo, useState } from 'react';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import LynIcon from 'components/@extended/LynIcon';
import TabPanel from 'components/TabPanel/TabPanel';
import plusIcon from 'assets/images/icons/plus.svg';
import comptroller from 'assets/images/comptroller_white.svg';
import { a11yProps, existTabItems } from 'pages/globals/global';
// import ListViewKeyManagementArea from './ListPageUtils/ListViewKeyManagementArea';
import { Box, Button, Grid, Stack, Tab, Tabs, Typography, useMediaQuery } from '@mui/material';
import { useGetAllIdentityCaseMutation, useGetCompanyInfoMutation, useGetModuleListMutation } from 'store/features/process/processApi';
import ListViewLeaseManagementArea from './ListPageUtils/ListViewLeaseManagementArea';
import ComptrollerPageHeader from 'components/header/ComptrollerPageHeader';
import SolutionCatalogIcon from 'assets/icons/solutions-catalog';

const DecommissionAssetManagement = ({ from = 'identity', forceActiveTab }) => {
	const theme = useTheme();
	const navigate = useNavigate();
	const params = useParams();
	const [searchParams] = useSearchParams();
	const [getAllIdentityCase, { data: getAllIdentityCaseData, isLoading: isDataLoading }] = useGetAllIdentityCaseMutation();
	const [tabsLoaded, setTabsLoaded] = useState(false);

	// Updated TabsItem with new tabs
	const { profileData } = useSelector((state) => state?.profile);

	// Set isRowClick based on the same logic as IdentityCaseList (default to false for IdentityFeaturedTable)
	const [data, setData] = useState([]);
	const [refresh, setRefresh] = useState(false);

	// Filter tabs to only show those with data
	const getTabsWithData = () => {
		if (!getAllIdentityCaseData || getAllIdentityCaseData.length === 0) {
			return []; // Don't show any tabs if no data yet
		}

		const tabsWithData = existTabItems.filter((tab) => {
			if (tab.data === 'All') {
				return getAllIdentityCaseData.length > 0; // Only show 'All' tab if there's actual data
			}
			if (tab.data === 'Worklist') {
				return getAllIdentityCaseData.some(
					(item) => item?.activationStatus === 'W-I-P' && item?.recordStatus === 'parked' && profileData?.userId === item?.approverUserId[0]
				);
			}
			if (tab.data === 'W-I-P') {
				// For W-I-P tab, exclude items that are in worklist (parked + user is approver)
				return getAllIdentityCaseData.some(
					(item) =>
						item?.activationStatus === 'W-I-P' && !(item?.recordStatus === 'parked' && profileData?.userId === item?.approverUserId[0])
				);
			}
			// Check if there's at least one item with this activation status
			return getAllIdentityCaseData.some((item) => item?.activationStatus === tab.data);
		});

		return tabsWithData;
	};

	const TabsItem = getTabsWithData();

	// Add normalization function for tab names
	// const normalizeTabName = (name) => name?.toLowerCase().replaceAll('-', '');

	// const [selectedTab, setSelectedTab] = useState(() => forceActiveTab || 'All');

	const [selectedTab, setSelectedTab] = useState(() => {
		const activeTab = searchParams.get('tab');

		if (activeTab) {
			const index = TabsItem?.findIndex((item) => item?.label?.toLowerCase()?.replaceAll('-', '') === activeTab);

			if (index > -1) {
				return index;
			}
		} else if (!forceActiveTab) {
			const index = TabsItem?.findIndex((item) =>
				(item?.label?.toLowerCase()?.replaceAll('-', '') === TabsItem?.[0]?.data) === 'Active' ? 'Active' : 'All'
			);

			if (index > -1) return index;
		} else if (forceActiveTab) {
			const index = TabsItem?.findIndex((item) => item?.label?.toLowerCase()?.replaceAll('-', '') === forceActiveTab?.toLowerCase());

			if (index > -1) return index;
		}
	});

	const [activeCreateButton, setActiveCreateButton] = useState(false);

	// const [getModuleList] = useGetModuleListMutation();

	const [GetCompanyInfo, { isLoading }] = useGetCompanyInfoMutation();

	const matchDownSM = useMediaQuery((theme) => theme.breakpoints.down('sm'));

	const selectTabHandler = (event, newValue) => {
		setSelectedTab(newValue);

		// const tabName = TabsItem?.[newValue]?.label?.toLowerCase()?.replaceAll('-', '');

		// if (params?.id) {
		// 	navigate(`/static/decommission-asset/${params.id}?tab=${tabName}`, { replace: true });
		// } else {
		// 	navigate(-1);
		// }

		// Update URL without navigation
		const newSearchParams = new URLSearchParams(window.location.search);
		newSearchParams.set('tab', newValue);
		window.history.replaceState(null, '', `${window.location.pathname}?${newSearchParams.toString()}`);
	};

	// Filter data based on selected tab
	const getFilteredData = useMemo(() => {
		if (!getAllIdentityCaseData) return [];

		const tabData = TabsItem?.[selectedTab]?.data;

		if (tabData === 'All') {
			return getAllIdentityCaseData;
		}
		if (tabData === 'Worklist') {
			return getAllIdentityCaseData.filter(
				(item) => item?.activationStatus === 'W-I-P' && item?.recordStatus === 'parked' && profileData?.userId === item?.approverUserId[0]
			);
		}
		if (tabData === 'W-I-P') {
			return getAllIdentityCaseData.filter(
				(item) => item?.activationStatus === 'W-I-P' && !(item?.recordStatus === 'parked' && profileData?.userId === item?.approverUserId[0])
			);
		}

		return getAllIdentityCaseData.filter((item) => item?.activationStatus === tabData);
	}, [getAllIdentityCaseData, selectedTab, profileData, TabsItem]);

	const paramsData = useMemo(() => {
		if (params?.id) {
			return decodeQueryParamData(params?.id);
		}
	}, []);

	// Create processDetails object for consistency
	const processDetails = {
		processCode: '10113',
		name: paramsData?.processName ?? '',
		version: '1.0',
	};

	// Create permissions object - disable delete for decommission asset management
	const permissionsObject = {
		read: true,
		write: true,
		edit: true,
		delete: false, // Disabled delete for decommission asset management
	};

	// Create headMetaData object
	const headMetaData = {
		meta: {
			staticFormUrl: '/static/decommission-asset',
		},
	};

	// Function to refetch data after operations
	const refetchData = () => {
		getAllIdentityCase({
			companyCode: '24155',
			operation: 'get-bulk',
			processCode: '10113',
			suffixCode: '',
		});
	};

	useEffect(() => {
		// Only set the selected tab once we have data and tabs
		if (getAllIdentityCaseData && TabsItem.length > 0) {
			const activeTab = searchParams.get('tab');

			if (TabsItem?.length > 0 && activeTab) {
				const index = TabsItem?.findIndex((item) => item?.label?.toLowerCase()?.replaceAll('-', '') === activeTab);

				if (index > -1) {
					setSelectedTab(index);

					setTabsLoaded(true);
					return;
				}
			} else if (!forceActiveTab) {
				const index = TabsItem?.findIndex((item) =>
					(item?.label?.toLowerCase()?.replaceAll('-', '') === TabsItem?.[0]?.data) === 'Active' ? 'Active' : 'All'
				);

				setSelectedTab(index);
			}

			setTabsLoaded(true);
		}
	}, [getAllIdentityCaseData, TabsItem, searchParams]);

	useEffect(() => {
		setActiveCreateButton(isLoading || isDataLoading);
	}, [isLoading, isDataLoading]);

	useEffect(() => {
		if (profileData) {
			GetCompanyInfo({
				companyCode: profileData?.creatorOrganizationId,
			});
		}
	}, [GetCompanyInfo, profileData]);

	useEffect(() => {
		getAllIdentityCase({
			companyCode: '24155',
			operation: 'get-bulk',
			processCode: '10113',
			suffixCode: '',
		});
	}, [getAllIdentityCase, refresh]);

	// Update data state when getAllIdentityCaseData changes
	useEffect(() => {
		if (getAllIdentityCaseData) {
			setData(getAllIdentityCaseData);
		}
	}, [getAllIdentityCaseData]);

	return (
		<Grid container rowSpacing={4.5} columnSpacing={2.75}>
			<Grid item xs={12}>
				<Grid item xs={12}>
					{from === 'identity' && (
						<ComptrollerPageHeader
							tabsItem={TabsItem}
							selectedTab={selectedTab}
							selectTabHandler={selectTabHandler}
							title={paramsData?.processName ?? ''}
							activeCreateButton={activeCreateButton}
							image={<SolutionCatalogIcon color="#fff" width="20px" height="20px" />}
							navigate={() =>
								navigate('/static/decommission-asset/create', {
									state: {
										assetList: getAllIdentityCaseData,
										processCode: '10113',
										processName: paramsData?.processName ?? '',
									},
								})
							}
						/>
					)}

					<Box sx={{ borderBottom: 1, borderColor: 'divider', width: '100%' }}>
						{TabsItem?.map((tab, index) => (
							<TabPanel TabPanel key={index} value={selectedTab} index={index} sx={{ height: 'calc(100% - 38px)' }}>
								<Box sx={{ background: '#fff', padding: '20px', borderRadius: '4px' }}>
									<ListViewLeaseManagementArea
										isLoading={isDataLoading}
										leaseList={getFilteredData}
										selectedTabName={tab.label}
										currentRoute="v6"
										// isRowClick={isRowClick}
										setData={setData}
										processDetails={processDetails}
										permissionsObject={permissionsObject}
										headMetaData={headMetaData}
										expectedURLToRedirect="/static/decommission-asset"
										setRefresh={setRefresh}
										refetchData={refetchData}
									/>
								</Box>
							</TabPanel>
						))}
					</Box>
				</Grid>
			</Grid>
		</Grid>
	);
};

export default DecommissionAssetManagement;
